<template lang="pug">
Table(stripe :columns="columns" :data="data")
</template>

<script>
import resourceUsageItemHistory from "@/components/resourceUsageItemHistory";
import { _dateFormat } from "@/libs/dateformat.js";
import Vue from "vue";
Vue.component("resourceUsageItemHistory", resourceUsageItemHistory);
export default {
    name: "resourceUsageItemHistory",
    props: {
        value: {},
    },
    data() {
        return {
            columns: [
                {
                    type: "expand",
                    width: 50,
                    render: (h, { row: { date, recordUsageCount, data } }) => {
                        const Tabs = h("resourceUsageItemHistory", {
                            props: {
                                value: data,
                            },
                        });

                        return h("div", [Tabs]);
                    },
                },
                {
                    title: "Date",
                    key: "date",
                    align: "center",
                },
                {
                    title: "Usage Count",
                    key: "recordUsageCount",
                    align: "center",
                },
            ],
            data: [],
        };
    },
    computed: {},
    methods: {},
    mounted() {
        const keys = Object.keys(this.value);
        this.data = keys.map((key) => {
            return {
                date: key,
                recordUsageCount: this.value[key].recordUsageCount,
                data: this.value[key].recordItems,
            };
        });
    },
};
</script>



// WEBPACK FOOTER //
// src/components/resourceUsageHistory.vue